import { emailTemplateTypes as actionTypes } from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const collectionState = {
  ...commonState.default({ collection: true }),
};

export const emailTemplateList = (state = collectionState, action) =>
  commonReducer(actionTypes.LIST, state, action);
